// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"8fbd54ef","714":"9841e159"}[chunkId] + ".chunk.js";
};